import React from "react";
import { Modal, Button } from "flowbite-react";
import { AiOutlineLoading } from "react-icons/ai";
import { HiOutlineExclamationCircle } from "react-icons/hi";

const ConfirmDeleteModal = ({
  open,
  onClose,
  onDelete,
  isLoading,
  taskTitle,
}) => {
  return (
    <Modal show={open} onClose={onClose} size="md" popup>
      <Modal.Header>Confirm Delete</Modal.Header>
      <Modal.Body className="space-y-4">
        <div className="text-center">
          <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
          <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">
            Are you sure you want to delete{" "}
            <strong>{taskTitle || "this task"}</strong>?
          </h3>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="failure"
          onClick={onDelete}
          disabled={isLoading}
          isProcessing={isLoading}
          processingSpinner={
            <AiOutlineLoading className="h-6 w-6 animate-spin" />
          }
        >
          Yes, delete
        </Button>
        <Button color="gray" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
